import { ConnectionStatus } from '../connection';
import { createError } from './create-error';

export const ConnectionError = createError(
  'ConnectionError',
  (status: ConnectionStatus) => `Failure to connect (status: ${status})`,
  {
    UNINITIALIZED: "Connection wasn't initialized prior to using it.",
    FAILED_TO_OPEN: 'Failed to open connection',
  } as const
);
export type ConnectionErrorInstance = InstanceType<typeof ConnectionError>;
